import { useState, type ReactNode } from "react";
import Modal from "./Modal";
import {
  PdfDownloadModalContext,
  type PdfDownloadModalContextValue,
} from "../../hooks/usePdfDownloadModal";

export function PdfDownloadModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState<(() => void) | null>(null);

  const showModal = (confirmCallback: () => void) => {
    setOnConfirm(() => confirmCallback);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    setOnConfirm(null);
  };

  const handleYes = () => {
    if (onConfirm) {
      onConfirm();
    }
    hideModal();
  };

  const handleNo = () => {
    hideModal();
  };

  const contextValue: PdfDownloadModalContextValue = { showModal, hideModal };

  return (
    <PdfDownloadModalContext.Provider value={contextValue}>
      {children}
      <PdfDownloadConfirmModalUI
        isOpen={isOpen}
        onYes={handleYes}
        onNo={handleNo}
      />
    </PdfDownloadModalContext.Provider>
  );
}

function PdfDownloadConfirmModalUI({
  isOpen,
  onYes,
  onNo,
}: {
  isOpen: boolean;
  onYes: () => void;
  onNo: () => void;
}) {
  const checkIcon = (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onNo}
      title="Download PDF Report"
      icon={checkIcon}
      iconBgColor="bg-blue-100"
      iconColor="text-blue-600"
    >
      <p className="text-sm text-gray-600 text-center mb-6">
        Are you sure you checked that everything is ok?
      </p>

      <div className="flex justify-center space-x-4">
        <button
          type="button"
          onClick={onNo}
          className="px-6 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 transition-colors hover:cursor-pointer"
        >
          NO
        </button>
        <button
          type="button"
          onClick={onYes}
          className="px-6 py-2 text-sm font-medium text-white bg-[#2f5241] border border-transparent rounded-md hover:bg-[#2f5241e1] focus:outline-none focus:ring-2 focus:ring-[#2f5241] focus:ring-offset-2 transition-colors hover:cursor-pointer"
        >
          YES
        </button>
      </div>
    </Modal>
  );
}

export default function PdfDownloadConfirmModal() {
  return null;
}
